import React, { useState } from 'react'
import NotificationsTab from '../../components/notificationsTabs/NotificationsTab';
import '../setting/Setting.css'
import PrivacyTab from '../../components/privacyTabs/PrivacyTab';
import SupportTab from '../../components/supportTabs/SupportTab';

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0); 
  return (
    <div className='dashboard-content-box dashboard-setting-content-box'>
    <div className="tabs-container setting-sec">
      <div className='innersetting-sec d-flex flex-wrap'>
        <div className="tabs-header sticky-md-top ">
          <button className={`tab-button ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}> Notifications </button>
          <button className={`tab-button ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}> Privacy </button>
          <button className={`tab-button ${activeTab === 2 ? "active" : ""}`} onClick={() =>  setActiveTab(2)}> Support </button>
        </div>

        <div className="tabs-content settingTabsSec">
          {activeTab === 0 && (
              <div className="tab-panel">
                 <NotificationsTab />
              </div>
          )}
          {activeTab === 1 && (
              <div className="tab-panel">
               <PrivacyTab />
              </div>
          )}
          {activeTab === 2 && (
              <div className="tab-panel">
                <SupportTab />
              </div>
          )}
        </div>
      </div>
    </div>
  </div>
  )
}

export default Settings
